import { useState } from "react"
import Header from "./components/Header"
import Tasks from "./components/Tasks"
import AddTask from "./components/AddTask"


const App = () => { 
  const [showAddTask , setShowAddTask ] = useState(false)
  const [tasks,setTasks] = useState( [   
    // {
  //     id: 1,
  //     text: 'doctor appointment',
  //     day: 'aug 21th at 6:26pm',
  //     reminder: true,
  //   },
  //  {
  //     id: 2,
  //     text: 'delivery of a car',
  //     day: 'aug 29th at 6:26pm',
  //     reminder: true,
  //   },
  //  {
  //     id: 3,
  //     text: 'Food shopping',
  //     day: 'aug 5th at 6:26pm',
  //     reminder: false,
  //   },
  
  ])

// Add Task
const addTask = (task) => {
  const id = Math.floor(Math.random()* 10000 +1)

  const newTask ={id ,...task }
  setTasks([...tasks, newTask])
}


//delete task
  const deleteTask =( id ) =>{
    setTasks(tasks.filter((task) => task.id !== id))
  }
//toogle reminder

const ToggleReminder = (id) => {
  setTasks(tasks.map((task) => 
     task.id === id ? { ...task, reminder: !task.reminder } : task
  ))
}

  return (
    <div className="container">
      <Header 
      onAdd={()=> setShowAddTask(!showAddTask)} showAdd={showAddTask} />

      {showAddTask && <AddTask onAdd={addTask} />}

      {tasks.length > 0 ?(<Tasks tasks={tasks} onDelete={deleteTask} onToggle = {ToggleReminder} />) : ('NO TASKES YET')}
    </div>
  );
}



export default App
